import React, { useState } from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Card, Container, Divider, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import lightsData from "../data/lightsData";

function ProductsDetails() {
  const { productsId } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const product = lightsData.categories
    .flatMap((category) => category.items)
    .find((item) => item.id === productsId);

  if (!product) {
    return (
      <MKBox my={6} py={6} textAlign="center">
        <MKTypography variant="h3" fontWeight="bold">
          제품을 찾을 수 없습니다.
        </MKTypography>
      </MKBox>
    );
  }

  // 대표 이미지 인덱스
  const [currentIndex, setCurrentIndex] = useState(0);
  const thumbnails = product.thumbnails;
  const maxThumbs = 10;
  const showThumbs = thumbnails.slice(0, maxThumbs);

  return (
    <MKBox bgColor="white">
      <Card sx={{ p: 2, mx: { xs: 2, lg: 3 }, mb: 4 }}>
        <Container sx={{ mt: 15 }}>
          {/* 대표 이미지 */}
          <MKBox textAlign="center">
            <MKBox
              component="img"
              src={thumbnails[currentIndex]}
              alt="대표 이미지"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                maxWidth: "800px",
              }}
            />
            {/* 썸네일 영역 */}
            <MKBox
              mt={2}
              sx={{
                overflowX: "auto",
                whiteSpace: "nowrap",
                mx: "auto",
                maxWidth: isMobile ? "100vw" : "950px", // 모바일에서 화면 꽉차게
                px: 1,
              }}
            >
              {showThumbs.map((thumb, idx) => (
                <MKBox
                  key={idx}
                  component="img"
                  src={thumb}
                  alt={`썸네일-${idx}`}
                  onClick={() => setCurrentIndex(idx)}
                  sx={{
                    display: "inline-block",
                    width: { xs: "55px", sm: "65px", md: "75px" },
                    height: { xs: "55px", sm: "65px", md: "75px" },
                    objectFit: "contain",
                    mx: 0.5,
                    cursor: "pointer",
                    border: idx === currentIndex ? "2px solid #1976d2" : "2px solid transparent",
                    borderRadius: 2,
                    transition: "border 0.15s",
                  }}
                />
              ))}
            </MKBox>
          </MKBox>
          {/* 정보 영역 아래는 이전과 동일 */}
          <MKTypography variant="body2" fontWeight="regular" color="textSecondary" mt={2}>
            <MKBox mt={10} mb={8}>
              <Divider
                sx={{
                  my: 2,
                  borderColor: "black",
                  borderBottomWidth: "2px",
                  borderStyle: "solid",
                }}
                color="black"
              />
              <MKTypography
                variant="h1"
                sx={{ mt: 10 }}
                fontWeight="bold"
                textAlign="center"
                textDecoration="underline"
              >
                {product.name}
              </MKTypography>
              <MKTypography variant="h2" sx={{ mt: 10 }} fontWeight="bold" textAlign="center">
                제품 상세
              </MKTypography>
            </MKBox>
            <MKBox component="div" my={4}>
              {product.details.map((detail, index) => {
                const isVideo =
                  detail.endsWith(".mp4") || detail.endsWith(".webm") || detail.endsWith(".ogg");
                return isVideo ? (
                  <MKBox
                    key={index}
                    component="video"
                    controls
                    src={detail}
                    alt={`detail-video-${index}`}
                    sx={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      maxWidth: "100%",
                      maxHeight: "800px",
                    }}
                  />
                ) : (
                  <MKBox
                    key={index}
                    component="img"
                    src={detail}
                    alt={`detail-image-${index}`}
                    sx={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      maxWidth: "100%",
                    }}
                  />
                );
              })}
            </MKBox>
          </MKTypography>
        </Container>
      </Card>
    </MKBox>
  );
}

export default ProductsDetails;
